import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { TMatchForm } from "@/features/match/types/MatchForm";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Grid, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

type TMatchJobIntroductionManagerInfoFormProps = {
  defaultValues: Partial<TMatchForm>;
};

export const MatchJobIntroductionManagerInfoForm: FCC<TMatchJobIntroductionManagerInfoFormProps> = ({ defaultValues: _defaultValues }) => {
  const methods = useFormContext<TMatchForm>();
  const { control } = methods;
  const MATCH_OFFICE_COUNT = 3;

  return (
    <InnerBox showDivider={false} padding={3}>
      <Stack alignItems="flex-start" spacing={2}>
        <Stack pb={1}>
          <Typography variant="head20Bold" color={black[30]}>
            職業紹介責任者情報
          </Typography>
        </Stack>
        {Array.from({ length: MATCH_OFFICE_COUNT }, (_, i) => (
          <Grid key={`match-office-${i}`} container columnGap={3} width="100%">
            <Grid item xs>
              <FormField control={control} name={`matchOffices.${i}.officeName`} label={`${i + 1}. 事業所名`} required={i === 0}>
                <Input placeholder="入力してください" />
              </FormField>
            </Grid>
            <Grid item xs>
              <FormField control={control} name={`matchOffices.${i}.fullName`} label="氏名">
                <Input placeholder="入力してください" />
              </FormField>
            </Grid>
            <Grid item xs>
              <FormField control={control} name={`matchOffices.${i}.trainingDate`} label="講習受講日">
                <InputDatePicker placeholder="2020/03/15" />
              </FormField>
            </Grid>
          </Grid>
        ))}
      </Stack>
    </InnerBox>
  );
};
